import Vue from 'vue';
import Vuetify, {
    VApp,
    VBtn,
    VCard,
    VCardText,
    VContainer,
    VContent,
    VDatePicker,
    VDialog,
    VDialogTransition,
    VFadeTransition,
    VFlex,
    VHover,
    VIcon,
    VLayout,
    VList,
    VListTile,
    VListTileTitle,
    VMenu,
    VRating,
    VSlider,
    VSpeedDial,
    VSwitch,
    VToolbar,
    VTooltip
} from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify, {
    iconfont: 'md',
    gridColumns: 24,
    components: {
        VApp,
        VBtn,
        VCard,
        VCardText,
        VContainer,
        VContent,
        VDialog,
        VDialogTransition,
        VDatePicker,
        VFlex,
        VHover,
        VIcon,
        VLayout,
        VList,
        VListTile,
        VListTileTitle,
        VMenu,
        VTooltip,
        VToolbar,
        VSwitch,
        VSlider,
        VFadeTransition,
        VRating,
        VSpeedDial
    },
    directives: {
        Ripple
    },
    theme: {
        primary: '#022341',
        accent: '#F2F2F2',
        sidebar: '#A7A9B3',
        secondary: '#39546B',
        info: '#1E3D59',
        action: '#7096D2',
        warning: '#F8981D',
        error: '#FF8181',
        urgent: '#DE1738',
        success: '#2E7D32',
        green: '#39C53F',
        grey: '#E5E5E5',
        white: '#FFFFFF',
        black: '#000000',
        inputBackground: '#F9F9F9',
        inputLabel: '#7096D2',
        inputText: '#000000'
    }
});
